(function () {
  'use strict';
  var ownScript = document.currentScript;
  var recordingPage = !!(ownScript && ownScript.getAttribute('data-recording-page') === 'true');
  var loaded = false;
  var recording = false;
  var armed = false;
  var timer = null;
  var interactions = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

  function allowed() {
    var cmp = window.Consentmo;
    return !!(cmp && typeof cmp.analyticsAllowed === 'function' && cmp.analyticsAllowed() === true);
  }

  // Shutdown stops capture but retains first-party identity cookies and storage.
  // Clear only FullStory's observed keys after an explicit Statistics denial.
  function clearIdentifiers() {
    var cmp = window.Consentmo;
    if (!cmp || typeof cmp.analyticsAllowed !== 'function' || cmp.analyticsAllowed() !== false) return;
    var hostname = window.location && window.location.hostname;
    if (hostname) {
      var domains = hostname.split('.');
      ['fs_uid', 'fs_lua'].forEach(function (name) {
        var expiry = name + '=; Max-Age=0; Path=/; SameSite=Lax';
        try { document.cookie = expiry; } catch (error) {}
        for (var i = 0; i < domains.length - 1; i += 1) {
          try { document.cookie = expiry + '; Domain=' + domains.slice(i).join('.'); } catch (error) {}
        }
      });
    }
    ['localStorage', 'sessionStorage'].forEach(function (storageName) {
      ['_fs_uid', '_fs_lua', '_fs_songs:1'].forEach(function (key) {
        try { window[storageName].removeItem(key); } catch (error) {}
      });
    });
  }

  function disarm() {
    if (timer !== null) clearTimeout(timer);
    timer = null;
    interactions.forEach(function (name) { window.removeEventListener(name, load); });
    armed = false;
  }

  function load() {
    if (!recordingPage || !allowed()) return;
    disarm();
    if (loaded) return;
    loaded = true;
    recording = true;
          window['_fs_host'] = 'fullstory.com';
          window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
          window['_fs_org'] = 'o-23BHQ9-na1';
          window['_fs_namespace'] = 'FS';
          !function(m,n,e,t,l,o,g,y){var s,f,a=function(h){
          return!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'),!1)}(e)
          ;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}
          d&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{
          then:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){
          h(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,""),"function"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}
          ;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){
          "function"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){
          (o=n.createElement(t)).async=!0,o.crossOrigin="anonymous",o.src="https://"+l,o.onerror=function(){y("Error loading "+l)}
          ;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}
          function h(b,h,d){g(b,h,d,1)}function d(b,d,j){h("setProperties",{type:b,properties:d},j)}function j(b,h){d("user",b,h)}function r(b,h,d){j({
          uid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h("trackEvent",{
          name:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h("shutdown")},g.restart=function(){h("restart")},
          g.log=function(b,d){h("log",{level:b,msg:d})},g.consent=function(b){h("setIdentity",{consent:!arguments.length||b})}}(),s="fetch",
          f="XMLHttpRequest",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v="2.0.0")
          }(window,document,window._fs_namespace,"script",window._fs_script);

  }

  // Outside the consent regions Consentmo fires consentmoSignal_onLoad before window.Consentmo exists and
  // sends no later signal, so re-check once the API appears (bounded: 240 x 250 ms).
  var waiting = false;
  function waitForConsentmo() {
    if (waiting || window.Consentmo || typeof window.setInterval !== 'function') return;
    waiting = true;
    var tries = 0;
    var id = window.setInterval(function () {
      tries += 1;
      if (!window.Consentmo && tries < 240) return;
      window.clearInterval(id);
      waiting = false;
      if (window.Consentmo) update();
    }, 250);
  }
  function update() {
    if (!window.Consentmo) {
      waitForConsentmo();
      return;
    }
    if (!allowed()) {
      disarm();
      if (recording && typeof window.FS === 'function') window.FS('shutdown');
      recording = false;
      clearIdentifiers();
      return;
    }
    if (!recordingPage) return;
    if (loaded) {
      if (!recording && typeof window.FS === 'function') window.FS('restart');
      recording = true;
    } else if (!armed) {
      armed = true;
      interactions.forEach(function (name) { window.addEventListener(name, load, { passive: true }); });
      timer = setTimeout(load, 30000);
    }
  }

  document.addEventListener('consentmoSignal_onLoad', update);
  document.addEventListener('consentmoSignal', update);
  update();
})();
